import { EXPERIMENT_KEY, SPARKFLOW_QUESTION_FORM_VARIANT, useABTesting, } from '@thoughtspot/experimentation';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { lazy, Suspense } from 'react';
import styles from './question-form.module.scss';
const QuestionFormV2 = lazy(() => import('./form-v2/form-v2'));
const QuestionFormV1 = lazy(() => import('./form-v1/form-v1'));
const loadingIndicator = (React.createElement(LoadingIndicator.Global, { className: styles.loadingIndicator },
    React.createElement(React.Fragment, null)));
export const QuestionForm = formProps => {
    const { variant, loading } = useABTesting(EXPERIMENT_KEY.SPARKFLOW_QUESTION_FORM_VARIANT);
    if (loading || formProps.isGeneratedIdsLoading) {
        return loadingIndicator;
    }
    return (React.createElement(Suspense, { fallback: loadingIndicator }, variant === SPARKFLOW_QUESTION_FORM_VARIANT.V2 ? (React.createElement(QuestionFormV2, { ...formProps })) : (React.createElement(QuestionFormV1, { ...formProps }))));
};
//# sourceMappingURL=question-form.js.map